export default __webpack_public_path__ + "assets/d495a3fd9185271fd3826ae645a22806.svg";